import {Inject, Injectable, Input, Output} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {CheckoutDTO} from "./checkoutdto";
import {Address} from "../domain/address";
import {Order} from "../domain/order";
import {User} from "../domain/user";
import {IS_BROWSER} from "../utils/injectiontokens";
import {LocalStorageService} from "../storage/local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

    protected data: CheckoutDTO = null;
    protected acceptTOUAndPP: boolean = false;
    protected volatileData: object;

    public checkoutSubject: BehaviorSubject<CheckoutDTO> = new BehaviorSubject(this.data);

    constructor(@Inject(IS_BROWSER) protected isBrowser: boolean,
                protected storageService: LocalStorageService) {

        this.data = new CheckoutDTO();
        this.volatileData = {};

        if(this.isBrowser) {
            const data = this.storageService.getObject<CheckoutDTO>("CheckoutData");
            if(data != null) {
                this.data = new CheckoutDTO(data);
                this.checkoutSubject.next(this.data);
            }
        }

    }

    public transformOrderToCheckoutData(order: Order) {
        this.setEmail(order.billingAddress.email);
        this.setBillingAddress(order.billingAddress);
        if(order.couponCode != null) {
            this.setCouponCode(order.couponCode);
        }
        this.setAcceptTOUAndPP(true);
    }

    public transformUserToCheckoutData(user: User) {
        this.setEmail(user.email);

        this.setAcceptTOUAndPP(true);
    }

    public saveData() {
        if(this.isBrowser) {
            this.storageService.setObject('CheckoutData', this.data);
        }
        this.checkoutSubject.next(this.data);
    }

    public getEmail(): string {
        return this.data.email;
    }

    public setEmail(email) {
        this.data.email = email;
        this.saveData();
    }

    public getPhone(): string {
        return this.data.phone;
    }

    public setPhone(phone) {
        this.data.phone = phone;
        this.saveData();
    }

    public getAcceptTOUAndPP(): boolean {
        return this.acceptTOUAndPP;
    }

    public setAcceptTOUAndPP(acceptTOUAndPP) {
        this.acceptTOUAndPP = acceptTOUAndPP;
    }

    public getCouponCode(): string {
        return this.data.couponCode;
    }

    public setCouponCode(couponCode) {
        this.data.couponCode = couponCode;
        this.saveData();
    }

    public getBillingAddress() {
        return this.data.getBillingAddress();
    }

    public setBillingAddress(address: Address) {
        this.data.setBillingAddress(address);
        this.saveData();
    }

    public getPaymentMethod(): string {
        return this.data.paymentMethod;
    }

    public setPaymentMethod(paymentMethod) {
        this.data.paymentMethod = paymentMethod;
        this.saveData();
    }



}
